import { useMemo } from 'react';
import { SideNav } from 'foundations-components/transitional/components/SideNav';
import UniversalAssociationsSelectSideNavItem from './UniversalAssociationsSelectSideNavItem';
import UniversalAssociationsSelectSideAllAssociationsNavItem from './UniversalAssociationsSelectSideAllAssociationsNavItem';
import { HR } from 'foundations-components/transitional/components/HR';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UniversalAssociationsSelectSideNav = ({
  associationRecords,
  allAssociationsCount,
  selectedObjectTypeId,
  onSetSelectedObjectTypeId,
  inlineSize = '160px'
}) => {
  const objectTypesNavList = useMemo(() => {
    if (!associationRecords) {
      return null;
    }
    const navItems = associationRecords.map(association => /*#__PURE__*/_jsx(UniversalAssociationsSelectSideNavItem, {
      association: association,
      selectedObjectTypeId: selectedObjectTypeId,
      onSetSelectedObjectTypeId: onSetSelectedObjectTypeId
    }, `association-nav-${association.get('toObjectTypeId')}`)).valueSeq();
    return /*#__PURE__*/_jsx(SideNav, {
      "aria-label": "Other Associations",
      marginBlockEnd: "0",
      marginBlockStart: "100",
      children: navItems
    });
  }, [associationRecords, onSetSelectedObjectTypeId, selectedObjectTypeId]);
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    paddingBlockStart: "200",
    paddingBlockEnd: "200",
    paddingInlineStart: "300",
    inlineSize: inlineSize,
    minInlineSize: inlineSize,
    overflowY: "scroll",
    borderInlineEndWidth: "100",
    borderInlineEndStyle: "solid",
    borderInlineEndColor: "border-core-default",
    children: [/*#__PURE__*/_jsx(SideNav, {
      "aria-label": "Selected Associations",
      marginBlockEnd: "0",
      marginBlockStart: "0",
      children: /*#__PURE__*/_jsx(UniversalAssociationsSelectSideAllAssociationsNavItem, {
        allAssociationsCount: allAssociationsCount,
        selectedObjectTypeId: selectedObjectTypeId,
        onSetSelectedObjectTypeId: onSetSelectedObjectTypeId
      })
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), objectTypesNavList]
  });
};
export default UniversalAssociationsSelectSideNav;